export type PortalConfig = { apiUrl: string; keycloakUrl: string; publicRealm: string; publicClientId: string };
declare global {
  interface Window {
    __IGOUDAR_PORTAL_CONFIG__?: Partial<PortalConfig>;
  }
}
export function readPortalConfig(
  input = window.__IGOUDAR_PORTAL_CONFIG__,
  origin = window.location.origin,
): PortalConfig {
  const keys = ["apiUrl", "keycloakUrl", "publicRealm", "publicClientId"] as const;
  if (keys.some((k) => typeof input?.[k] !== "string" || !input[k]?.trim())) throw new Error("portal.configuration");
  const config = input as PortalConfig;
  for (const key of ["apiUrl", "keycloakUrl"] as const) {
    const url = new URL(config[key], origin);
    if (!["http:", "https:"].includes(url.protocol) || url.username || url.password || url.search || url.hash)
      throw new Error("portal.configuration");
  }
  return { ...config, apiUrl: config.apiUrl.replace(/\/$/, ""), keycloakUrl: config.keycloakUrl.replace(/\/$/, "") };
}
export function publicTokenMatches(token: { iss?: string; aud?: string | string[] } | undefined, config: PortalConfig) {
  return (
    token?.iss === `${config.keycloakUrl}/realms/${config.publicRealm}` &&
    (Array.isArray(token.aud) ? token.aud : [token.aud]).includes("igoudar-public-api")
  );
}
export function portalPath(path: string) {
  const pathname = path.split("?", 1)[0];
  return (
    /^\/portal\//.test(pathname) &&
    !pathname.includes("..") &&
    !pathname.includes("\\") &&
    !pathname.includes("%") &&
    !path.includes("#")
  );
}
